import { forwardRef, useImperativeHandle, useRef, useState } from "react"
import { FaPlusCircle } from "react-icons/fa"
import ProductListItem from "./ProductListItem"

export default forwardRef(({
  products: productsProp,
  onChange: onChangeProp
}, ref) => {
  const [products, setProducts] = useState(() => generateIdWithProduct(productsProp))
  const productRefs = useRef({})

  function generateIdWithProduct (products) {
    return (productsProp || []).map(p => ({
      id: crypto.randomUUID(),
      value: p
    }))
  }

  const onChange = (id, product) => {
    const clone = [ ...products ]
    const index = clone.findIndex(p => p.id === id)
    if (!id) {
      clone[clone.length] = { id: crypto.randomUUID(), value: product }
    } else if (product) {
      clone[index].value = {...product}
    } else {
      clone.splice(index, 1)
      delete productRefs[id]
    }
    setProducts(clone)
    //console.log({ source: 'productlist.onchange', id, index, product, products, clone})

    onChangeProp?.(clone.map(p => p.value))
  }

  useImperativeHandle(ref, () => ({
    isValid: () => {
      return Object.values(productRefs.current).reduce((prev, curr) => {
        // Note, don't use && because that will short-circuit the evaluation if the first is true and never run the second
        return prev & (curr ? curr.isValid() : true)
      }, true)
    }
  }), [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', flex: 1 }}>
      {products?.map(({ id, value: product }) => 
        <ProductListItem 
          key={id} 
          ref={r => productRefs.current[id] = r} 
          product={product} 
          onChange={p => onChange(id, p)} 
          onRemove={p => onChange(id, undefined)} 
        />
      )}
      <span style={{ display: 'inline-block', cursor: 'pointer' }} onClick={() => onChange(undefined, {})}>
        <FaPlusCircle />
      </span>
    </div>
  )
})